import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepIcon from "@mui/material/StepIcon";
import StepButton from "@mui/material/StepButton";
import styled from "styled-components";

const StyledHorizontalLineDiv = styled.div`
  height: 1;
  width: 50px;
`;
const StyledHorizontalLine = styled.hr`
  border: 1px dashed ${(props) => props.theme.palette.dark.c200};
`;
const StyledStepper = styled(Stepper).attrs()`
.MuiStepLabel-label.Mui-active{
  color:${(props) => props.theme.palette.primary.c03};
  font-weight: ${(props) => props.theme.typography.helperText};
  font-size: 12px;
  font-family: ${(props) => props.theme.typography.baseFontFamily};
}
.MuiStepLabel-label{
  color:${(props) => props.theme.palette.dark.c200};
  font-weight: ${(props) => props.theme.typography.helperText};
  font-family: ${(props) => props.theme.typography.baseFontFamily};
  font-size: 12px;
}
.MuiStepLabel-label.Mui-completed{
  color:${(props) => props.theme.palette.primary.c03};
  font-weight: ${(props) => props.theme.typography.helperText};
  font-family: ${(props) => props.theme.typography.baseFontFamily};
  font-size: 12px;
}
.MuiStepIcon-root.Mui-active{
  border: 1px solid ${(props) => props.theme.palette.primary.c03};
color: ${(props) => props.theme.palette.primary.c03};
width: 24px;
height: 24px;
border-radius: 12px;
.MuiStepIcon-text{
  fill: ${(props) => props.theme.palette.common.white};
  font-weight: ${(props) => props.theme.typography.label};
  font-family: ${(props) => props.theme.typography.baseFontFamily};
  font-size: 12px;
}
  
}
.MuiStepIcon-root{
  border: 1px solid ${(props) => props.theme.palette.primary.c03};
  color: ${(props) => props.theme.palette.common.white};
  width: 24px;
  height: 24px;
  border-radius: 12px;
  .MuiStepIcon-text{
    fill: ${(props) => props.theme.palette.primary.c03};
    font-weight: ${(props) => props.theme.typography.label};
    font-family: ${(props) => props.theme.typography.baseFontFamily};
  font-size: 12px;
  }
}
.MuiStepIcon-root.Mui-completed{
  border: 1px solid ${(props) => props.theme.palette.primary.c03};
  color: ${(props) => props.theme.palette.primary.c03};
  width: 24px;
  height: 24px;
  border-radius: 12px;
  .MuiStepIcon-text{
    fill: ${(props) => props.theme.palette.common.white};
    font-weight: ${(props) => props.theme.typography.label};
    font-family: ${(props) => props.theme.typography.baseFontFamily};
    font-size: 12px;
  }
}
}
`;
export default function HorizontalStepper(props) {
  const steps = props.steps;
  const handleStepChange = (step) => {
    props.onChangeStep(step);
  };

  return (
    <div style={{ marginLeft: "-8px" }}>
      <StyledStepper
        connector={
          <StyledHorizontalLineDiv>
            <StyledHorizontalLine />
          </StyledHorizontalLineDiv>
        }
        activeStep={props.activeStep}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton onClick={() => handleStepChange(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </StyledStepper>
    </div>
  );
}
